import {ApolloLink, Observable} from '@apollo/client';
import Keycloak from 'keycloak-js';
import {GraphqlRouting} from '../service/graphql-routing';
import {environment} from '../../environments/environment';

export function createApolloAuthMiddleware(keycloak: Keycloak, routingService: GraphqlRouting): ApolloLink {
  return new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      let handle: any;

      Promise.resolve()
        .then(() => {
          return keycloak.updateToken(30);
        })
        .then(() => {
          const token = keycloak.token;
          const uri = environment.serverUrl + routingService.resolveUri(operation.operationName);

          operation.setContext(({headers = {}}) => ({
            headers: token ? {...headers, Authorization: `Bearer ${token}`} : headers,
            uri
          }));

          if (forward) {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            });
          } else {
            observer.complete();
          }
        })
        .catch(error => {
          keycloak.login();
          observer.error(error);
        });

      return () => {
        if (handle) handle.unsubscribe();
      };
    });
  });
}
